import React from 'react'
import Form from 'react-bootstrap/Form'

interface SelectInterface {
  classNames?: string,
  classNamesForm?: string,
  classNamesGroup?: string,
  controlId?: string,
  defaultValue?: string|any[],
  error?: string,
  label?: string,
  labelRequired?: boolean,
  name?: string,
  onChange: Function,
  options: Object|any[],
  value?: string|number,
  inline?: boolean,
  disabled?: boolean
}

const Select = ({
  name,
  value,
  error = '',
  label,
  labelRequired,
  controlId,
  classNames,
  classNamesForm,
  classNamesGroup,
  defaultValue,
  onChange,
  options,
  inline = true,
  disabled = false
}: SelectInterface) => {
  return (
    <div className={classNamesForm}>
      <Form.Group controlId={controlId} className={classNamesGroup}>
        {label && (
          <Form.Label>
            {label}
            {labelRequired && <span className="text-red"> *</span>}
          </Form.Label>
        )}
        <Form.Select
          className={`form-control ${classNames} ${error && ' is-invalid'}`}
          defaultValue={defaultValue}
          onChange={onChange}
          value={value}
          name={name}
          disabled={disabled}
        >
          {options}
        </Form.Select>
        {error && (
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        )}
      </Form.Group>
    </div>
  )
}

export default Select
